import template from './organizationAdd.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdDialog,
      $mdMedia,
      $timeout,
      eventService,
      organizationService,
      uiService,
      Organization,
      INSTANCE
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onOrganizationAdd(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                organization: Organization.blank()
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (organization) {
              organizationService.cloneOrganization(organization).then(function (data) {
                if (data.status) {
                  organization.id = data.id;
                  organization.isNew = true;
                  ctrl.onFinished({ organization: organization });
                  uiService.toast({
                    text: {
                      p1: 'Organization',
                      p2: organization.getName(),
                      p3: 'has been added'
                    }
                  });
                }
              });
            });

          function dialogController($scope, $rootScope, INSTANCE, $mdDialog, organization) {
            this.INSTANCE = INSTANCE;
            this.IsEnterprise = $rootScope.IsEnterprise;
            this.organization = organization;
            this.isCheckingUrlAvailability = false;
            this.isUrlAvailable = false;
            var self = this;
            this.sanitizeUrlInput = function ($event) {
              $timeout(function () {
                if (self.organization.organization.url) {
                  self.organization.organization.url = self.organization.organization.url.replace(
                    /[^a-z0-9\s-]/g,
                    ''
                  );
                  self.organization.organization.url = self.organization.organization.url.replace(
                    /\s+/g,
                    ''
                  );
                  self.organization.organization.url = self.organization.organization.url.replace(
                    /\s/g,
                    '-'
                  );
                  self.checkUrlAvailability();
                }
              });
            };
            this.validateUrlInput = function ($event) {
              if (
                String.fromCharCode($event.keyCode || $event.charCode).match(/[^a-z0-9\s-]/g)
              ) {
                $event.preventDefault();
              } else {
                self.sanitizeUrlInput();
              }
            };
            this.checkUrlAvailability = function () {
              $timeout(function () {
                if (
                  self.organization.organization.url &&
                  self.organization.organization.url.length >= 6 &&
                  self.organization.organization.url.length <= 32 &&
                  self.isCheckingUrlAvailability === false
                ) {
                  self.isCheckingUrlAvailability = true;
                  organizationService
                    .isUrlAvailable({ url: self.organization.organization.url })
                    .then(function (result) {
                      $scope.organizationAdd.url.$setValidity('available', result);
                      self.isUrlAvailable = result;
                      self.isCheckingUrlAvailability = false;
                    });
                }
              });
            };
            this.confirm = function () {
              if (
                this.organization.organization.name !== '' &&
                this.organization.organization.url !== '' &&
                this.isUrlAvailable
              ) {
                $mdDialog.hide(this.organization);
              } else {
                uiService.toast({
                  text: {
                    p1: 'Organization',
                    p2: 'name and available URL',
                    p3: 'are required'
                  },
                  warn: true
                });
              }
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
